var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('m.summary'),"name":"first"}},[_c('chart')],1),_c('el-tab-pane',{attrs:{"label":_vm.$t('m.detail'),"name":"second"}},[_c('record')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }